// initial state
const state = () => ({
  legs: [],
  activeLeg: undefined,
  defaultLeg: undefined,
  valueType: "leg",
  emptyOption: {
    value: "",
    label: "Choose leg",
  },
});

// getters
const getters = {
  getLegs: (state) => {
    return state.legs;
  },
  getActiveLeg: (state) => {
    return state.activeLeg;
  },
  getDefaultLeg: (state) => {
    return state.defaultLeg;
  },
  getMatchingLeg: (state) => (sku_code) => {
    return state.legs.find((leg) => leg.sku_code === sku_code);
  },
  getValueType: (state) => {
    return state.valueType;
  },
  getEmptyOption: (state) => {
    return state.emptyOption;
  },
  queryLegs: (state) => (queryObject) => {
    const queryCopy = Object.assign({}, queryObject);
    let findMultiple = false;
    if (queryCopy.findMultiple) {
      findMultiple = queryCopy.findMultiple;
      delete queryCopy.findMultiple;
    }
    const findFunction = (leg) => {
      let isMatch = true;
      Object.keys(queryCopy).forEach((key) => {
        if (!leg[key] || leg[key].trim() !== queryCopy[key].trim()) {
          isMatch = false;
        }
      });
      return isMatch;
    };
    if (findMultiple) {
      return state.legs.filter(findFunction);
    } else {
      return state.legs.find(findFunction);
    }
  },
};

// actions
const actions = {
  setLegs({ commit }, legs) {
    commit("setLegs", { legs });
  },
  activateLeg({ commit }, newLeg) {
    commit("setActiveLeg", { newLeg });
  },
  setDefaultLeg({ commit }, defaultLeg) {
    commit("setDefaultLeg", { defaultLeg });
  },
};

// mutations
const mutations = {
  setLegs(state, { legs }) {
    state.legs = [...legs];
  },
  setActiveLeg(state, { newLeg }) {
    state.activeLeg = { ...newLeg };
  },
  setDefaultLeg(state, { defaultLeg }) {
    state.defaultLeg = { ...defaultLeg };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
